// @flow

import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import get from 'lodash.get';

import AddressForm from 'dibs-address-form';

import { commit } from '../mutations/UpdateProjectMutation';
import { postProjectToFA } from '../faPoster';

import styles from './styles/UpdateShippingAddress.scss';

import type { Environment } from 'react-relay';
import type { IntlShape } from 'react-intl';
import type { Address, FormStatus, Project } from '../types.flow';

export type UpdateShippingAddressProps = {|
    firmId: ?string,
    onSuccess?: (payload: Project) => mixed,
    project: Project,
    relayEnvironment: Environment,
    source: string,
    userId: string,
|};

type UpdateShippingAddressComponentProps = {|
    ...UpdateShippingAddressProps,
    intl: IntlShape,
|};

type UpdateShippingAddressState = {|
    formStatus: FormStatus,
|};

type AddressFormSubmitPayload = {|
    address: Address,
    isValid: boolean,
|};

export class UpdateShippingAddress extends React.Component<
    UpdateShippingAddressComponentProps,
    UpdateShippingAddressState
> {
    constructor(props: UpdateShippingAddressComponentProps) {
        super(props);
        this.handleMutationError = this.handleMutationError.bind(this);
        this.handleMutationSuccess = this.handleMutationSuccess.bind(this);
        this.submit = this.submit.bind(this);

        this.state = {
            formStatus: 'DEFAULT',
        };
    }

    handleMutationError: (error: mixed) => void;
    handleMutationSuccess: (payload: Project) => void;
    submit: (payload: AddressFormSubmitPayload) => void;

    handleMutationError(error: mixed) {
        this.setState({ formStatus: 'ERROR' });
        console.error('install date update failed:', error);
    }

    handleMutationSuccess(payload: Project) {
        const { firmId, onSuccess, source, userId } = this.props;
        const project = get(payload, 'updateProject.project');

        postProjectToFA({
            action: 'UPDATE',
            firmId,
            project,
            source,
            userId,
        });

        if (typeof onSuccess === 'function') {
            onSuccess(payload);
        }
    }

    submit({ address, isValid }: AddressFormSubmitPayload) {
        const { formStatus } = this.state;
        const { project, relayEnvironment } = this.props;

        if (formStatus === 'LOADING') {
            return;
        }

        if (!isValid) {
            this.setState({ formStatus: 'DEFAULT' });
            return;
        }

        this.setState({ formStatus: 'LOADING' });

        commit(relayEnvironment, {
            shippingAddress: address,
            projectId: project.serviceId,
            onCompleted: this.handleMutationSuccess,
            onError: this.handleMutationError,
        });
    }

    render() {
        const { project, relayEnvironment } = this.props;
        const { formStatus } = this.state;

        return (
            <div>
                <AddressForm
                    address={project.shippingAddress || {}}
                    environment={relayEnvironment}
                    fields={['line1', 'city', 'country', 'zipCode', 'state']}
                    onSubmit={this.submit}
                />
                {formStatus === 'ERROR' && (
                    <div className={styles.errorMessage}>
                        <FormattedMessage
                            id="dc.ProjectForms.UpdateShippingAddress.errorMessage"
                            defaultMessage="An error occurred. Shipping address could not be updated."
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default injectIntl(UpdateShippingAddress);
